import { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import {
    FaChevronDown,
    FaChevronRight,
    FaCogs,
    FaFileAlt,
    FaNewspaper,
    FaDonate,
    FaClipboardList,
    FaUsers,
    FaFolderOpen,
    FaHandsHelping,
    FaEnvelope,
    FaMoneyCheckAlt,
    FaPowerOff,
    FaHome,
    FaTimes,
    FaChevronLeft,
} from 'react-icons/fa'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import LanguageSwitchButton from '../../public/components/LanguageSwitchButton'
import { languageUtil } from '../../util/languageUtils'

// export const navItems = [
//     {
//         name: 'Dashboard',
//         path: '/admin/auth/dashboard',
//         icon: <FaHome />,
//     },
//     {
//         name: 'News (Appeals)',
//         path: '/admin/auth/news',
//         icon: <FaNewspaper />,
//     },
//     {
//         name: 'Religious Dues',
//         path: '/admin/auth/religious-dues',
//         icon: <FaDonate />,
//     },
//     {
//         name: 'Projects',
//         icon: <FaFolderOpen />,
//         children: [
//             {
//                 name: 'Project List',
//                 path: '/admin/auth/projects',
//                 icon: <FaNewspaper />,
//             },
//             {
//                 name: 'Categories',
//                 path: '/admin/auth/project-categories',
//                 icon: <FaClipboardList />,
//             },
//             {
//                 name: 'Journeys',
//                 path: '/admin/auth/project-journeys',
//                 icon: <FaFileAlt />,
//             },
//         ],
//     },
//     {
//         name: 'Donations',
//         icon: <FaDonate />,
//         children: [
//             {
//                 name: 'Manage Donations',
//                 path: '/admin/auth/donations',
//                 icon: <FaClipboardList />,
//             },
//             {
//                 name: 'Payment Logs',
//                 path: '/admin/auth/payment-logs',
//                 icon: <FaMoneyCheckAlt />,
//             },
//         ],
//     },
//     {
//         name: 'Get Involved',
//         icon: <FaHandsHelping />,
//         children: [
//             {
//                 name: 'Volunteers',
//                 path: '/admin/auth/volunteers',
//                 icon: <FaUsers />,
//             },
//         ],
//     },
//     {
//         name: 'Newsletter',
//         icon: <FaEnvelope />,
//         children: [
//             {
//                 name: 'Subscriptions',
//                 path: '/admin/auth/newsletter-subscribers',
//                 icon: <FaUsers />,
//             },
//             {
//                 name: 'Campaigns',
//                 path: '/admin/auth/newsletter-campaigns',
//                 icon: <FaFileAlt />,
//             },
//         ],
//     },
//     {
//         name: 'Donators',
//         path: '/admin/auth/donation-billings',
//         icon: <FaUsers />,
//     },
//     {
//         name: 'Platform Information',
//         path: '/admin/auth/platform-information',
//         icon: <FaCogs />,
//     },
// ]

const Sidebar = ({ onToggleMinimize }) => {
    const location = useLocation()
    const [openMenus, setOpenMenus] = useState([])
    const [isMinimized, setIsMinimized] = useState(false)
    const { t } = useTranslation()
    const { language } = languageUtil()

    const isRTL = language === 'ar'

    const navigate = useNavigate()

    const toggleMenu = name => {
        setOpenMenus(prev => (prev.includes(name) ? prev.filter(n => n !== name) : [...prev, name]))
    }

    // useEffect(() => {
    //     const savedState = localStorage.getItem('sidebarMinimized')
    //     if (savedState) {
    //         const minimized = JSON.parse(savedState)
    //         setIsMinimized(minimized)
    //         onToggleMinimize(minimized)
    //     }
    // }, [onToggleMinimize])

    const handleToggle = () => {
        const newState = !isMinimized
        setIsMinimized(newState)
        onToggleMinimize(newState)
        localStorage.setItem('sidebarMinimized', JSON.stringify(newState))
    }
    const navItems = [
        {
            name: t('navigation_admin.dashboard'),
            path: '/admin/auth/dashboard',
            icon: <FaHome />,
            key: 'dashboard', // Added for toggleMenu reference
        },
        {
            name: t('navigation_admin.news.main'),
            path: '/admin/auth/news',
            icon: <FaNewspaper />,
            key: 'news',
        },
        {
            name: t('navigation_admin.religious_dues'),
            path: '/admin/auth/religious-dues',
            icon: <FaDonate />,
            key: 'religious_dues',
        },
        {
            name: t('navigation_admin.projects.main'),
            icon: <FaFolderOpen />,
            key: 'projects',
            children: [
                {
                    name: t('navigation_admin.projects.list'),
                    path: '/admin/auth/projects',
                    icon: <FaNewspaper />,
                    key: 'project_list',
                },
                {
                    name: t('navigation_admin.projects.categories'),
                    path: '/admin/auth/project-categories',
                    icon: <FaClipboardList />,
                    key: 'project_categories',
                },
                {
                    name: t('navigation_admin.projects.journeys'),
                    path: '/admin/auth/project-journeys',
                    icon: <FaFileAlt />,
                    key: 'project_journeys',
                },
            ],
        },
        {
            name: t('navigation_admin.donations.main'),
            icon: <FaDonate />,
            key: 'donations',
            children: [
                {
                    name: t('navigation_admin.donations.manage'),
                    path: '/admin/auth/donations',
                    icon: <FaClipboardList />,
                    key: 'manage_donations',
                },
                {
                    name: t('navigation_admin.donations.payment_logs'),
                    path: '/admin/auth/payment-logs',
                    icon: <FaMoneyCheckAlt />,
                    key: 'payment_logs',
                },
            ],
        },
        {
            name: t('navigation_admin.get_involved.main'),
            icon: <FaHandsHelping />,
            key: 'get_involved',
            children: [
                {
                    name: t('navigation_admin.get_involved.volunteers'),
                    path: '/admin/auth/volunteers',
                    icon: <FaUsers />,
                    key: 'volunteers',
                },
            ],
        },
        {
            name: t('navigation_admin.newsletter.main'),
            icon: <FaEnvelope />,
            key: 'email',
            children: [
                {
                    name: t('navigation_admin.newsletter.subscriptions'),
                    path: '/admin/auth/email-subscribers',
                    icon: <FaUsers />,
                    key: 'subscriptions',
                },
                {
                    name: t('navigation_admin.newsletter.campaigns'),
                    path: '/admin/auth/email-campaigns',
                    icon: <FaFileAlt />,
                    key: 'campaigns',
                },
            ],
        },
        {
            name: t('navigation_admin.donators'),
            path: '/admin/auth/donation-billings',
            icon: <FaUsers />,
            key: 'donators',
        },
        {
            name: t('navigation_admin.platform_information'),
            path: '/admin/auth/platform-information',
            icon: <FaCogs />,
            key: 'platform_information',
        },
    ]

    return (
        <aside
            className={clsx(
                'fixed top-0 h-screen p-4 space-y-2 font-light text-gray-900 bg-white transition-all duration-300 flex flex-col z-50',
                isRTL ? 'right-0 border-l' : 'left-0 border-r',
                isMinimized ? 'w-16 md:w-18' : 'w-64',
                'transform md:translate-x-0',
                'mobile-menu'
            )}
            style={{
                // Mobile-specific behavior
                '@media (max-width: 767px)': {
                    transform: isMinimized ? 'translateX(-100%)' : 'translateX(0)',
                    width: '80%', // Take up most of screen on mobile
                    boxShadow: isMinimized ? 'none' : '0 0 15px rgba(0,0,0,0.1)',
                },
            }}
        >
            <div className={clsx('absolute top-0 m-4', isRTL ? 'left-0' : 'right-0')}>
                <button onClick={handleToggle} className='p-2 rounded-full hover:bg-gray-200'>
                    {isMinimized ? isRTL ? <FaChevronLeft /> : <FaChevronRight /> : <FaTimes />}
                </button>
            </div>

            <div className='flex items-start justify-between h-24 px-2'>
                {!isMinimized && (
                    <div>
                        <a href='/' target='_blank' rel='noopener noreferrer'>
                            <img src='/logo.jpeg' className='h-6 max-w-[180px] mb-4' alt='Logo' />
                        </a>
                        <LanguageSwitchButton />
                    </div>
                )}
            </div>

            {/* Scrollable area */}
            <div className='flex-1 overflow-y-auto custom-scrollbar'>
                {navItems.map(item => (
                    <div key={item.name} className='py-1'>
                        {!item.children ? (
                            <Link
                                to={item.path}
                                className={clsx(
                                    'flex items-center gap-2 px-2 py-3 rounded hover:bg-gray-200 h-12',
                                    'text-sm md:text-base', // Responsive text size
                                    location.pathname.startsWith(item.path) &&
                                        'bg-gray-200 font-semibold'
                                )}
                                title={isMinimized ? item.name : undefined}
                                // onClick={() => window.innerWidth < 768 && setIsMinimized(true)}
                            >
                                <span className='flex-shrink-0 text-lg'>{item.icon}</span>
                                {!isMinimized && <span className='truncate'>{item.name}</span>}
                            </Link>
                        ) : (
                            <div>
                                <button
                                    onClick={() => {
                                        // Auto-expand sidebar if minimized
                                        if (isMinimized) {
                                            setIsMinimized(false)
                                            // Open menu after slight delay for animation
                                            setTimeout(() => toggleMenu(item.name), 100)
                                        } else {
                                            toggleMenu(item.name)
                                        }
                                    }}
                                    className='flex items-center justify-between w-full h-12 px-2 py-3 rounded hover:bg-gray-200'
                                    title={isMinimized ? item.name : undefined}
                                >
                                    <div className='flex items-center gap-2'>
                                        <span className='flex-shrink-0 text-lg'>{item.icon}</span>
                                        {!isMinimized && (
                                            <span className='text-sm truncate md:text-base'>
                                                {item.name}
                                            </span>
                                        )}
                                    </div>
                                    {!isMinimized &&
                                        (openMenus.includes(item.name) ? (
                                            <FaChevronDown className='flex-shrink-0 text-sm' />
                                        ) : isRTL ? (
                                            <FaChevronLeft className='flex-shrink-0 text-sm' />
                                        ) : (
                                            <FaChevronRight className='flex-shrink-0 text-sm' />
                                        ))}
                                </button>

                                {openMenus.includes(item.name) && !isMinimized && (
                                    <div className='mt-1 ml-6 space-y-1'>
                                        {item.children.map(child => (
                                            <Link
                                                key={child.name}
                                                to={child.path}
                                                className={clsx(
                                                    'flex items-center gap-2 px-2 py-3 rounded hover:bg-gray-200',
                                                    'text-sm md:text-base',
                                                    location.pathname.startsWith(child.path) &&
                                                        'bg-gray-200 font-semibold'
                                                )}
                                                title={child.name}
                                                // onClick={() =>
                                                //     window.innerWidth < 768 && setIsMinimized(true)
                                                // }
                                            >
                                                <span className='flex-shrink-0 text-base'>
                                                    {child.icon}
                                                </span>
                                                <span className='truncate'>{child.name}</span>
                                            </Link>
                                        ))}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                ))}
            </div>

            {/* Logout button */}
            <button
                className='flex items-center h-12 gap-2 px-2 py-3 mt-auto text-red-800 rounded'
                onClick={() => {
                    localStorage.removeItem('token')
                    localStorage.removeItem('adminData')
                    navigate('/admin/login')
                }}
            >
                <FaPowerOff className='flex-shrink-0' />
                {!isMinimized && (
                    <span className='text-sm truncate md:text-base'>
                        {t('navigation_admin.logout')}
                    </span>
                )}
            </button>
        </aside>
    )
}

export default Sidebar
